import React, { Fragment, useContext } from "react";
import { useFormContext } from "react-hook-form";
import {
  BuilderFieldButton,
  BuilderFieldCategoryName,
  BuilderFieldListItem,
  BuilderFieldsList,
} from "../__styles__/SubmissionsBuilder";
import { fieldCategoryToFieldTypesMap } from "../constants";
import { SubmissionsBuilderContextInstance } from "../context";
import { makeUniqueFieldName } from "../helpers";
import { SubmissionsBuilderFormDataStructure } from "../types";
import { buildFieldSchemaMap } from "../utils";

const FieldsList = () => {
  const { appendFnsByFieldArrayPath, selectedField } = useContext(
    SubmissionsBuilderContextInstance,
  );
  const fieldArrayPath =
    selectedField === null ? "inputs" : `${selectedField.fieldPath}.properties`;
  const append = appendFnsByFieldArrayPath[fieldArrayPath];
  const { watch } = useFormContext<SubmissionsBuilderFormDataStructure>();
  const canCreateRolesAndGroupIds = watch("canCreateRolesAndGroupIds");
  const hiddenFromPublicByDefault = watch("hiddenFromPublicByDefault");

  if (!append) {
    return null;
  }

  return (
    <div>
      {Object.entries(fieldCategoryToFieldTypesMap).map(
        ([category, fieldTypes]) => (
          <Fragment key={category}>
            <BuilderFieldCategoryName>{category}</BuilderFieldCategoryName>
            <BuilderFieldsList>
              {fieldTypes.map(fieldType => (
                <BuilderFieldListItem key={fieldType.name}>
                  <BuilderFieldButton
                    onClick={() => {
                      append({
                        ...buildFieldSchemaMap({
                          fieldTypeName: fieldType.name,
                          canCreateRolesAndGroupIds,
                          hiddenFromPublicByDefault,
                        }),
                        name: makeUniqueFieldName(),
                      });
                    }}
                    styleVariant="ghost"
                    leftIconName={fieldType.icon}
                    aria-label={`Add ${fieldType.label} field`}
                  >
                    {fieldType.label}
                  </BuilderFieldButton>
                </BuilderFieldListItem>
              ))}
            </BuilderFieldsList>
          </Fragment>
        ),
      )}
    </div>
  );
};

export default FieldsList;
